import React, { useState } from "react"
import { Box, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material"
import { autoEuropeDrawerData } from "Pages/AutoEuropeTool/Page/@signals"

export default function AutoEuropeCompareBy() {
	const initial = autoEuropeDrawerData.peek().compareByCategory ?? false
	const [selected, setSelected] = useState(initial ? 'category' : 'acriss')

	const handleChange = (_, newVal) => {
		if (newVal === null) return
		setSelected(newVal)
		autoEuropeDrawerData.value = {
			...autoEuropeDrawerData.value,
			compareByCategory: newVal === 'category',
			filterAcriss: [],
			filterAcrissExclusion: false,
			filterCategories: [],
			filterCategoriesExclusion: false,
		}
	}

	return (
		<Box>
			<Typography variant="body2" sx={{ mb: 1, fontWeight: 500 }}>Compare By</Typography>
			<ToggleButtonGroup value={selected} exclusive onChange={handleChange} size="small">
				<ToggleButton value="acriss">ACRISS</ToggleButton>
				<ToggleButton value="category">Category</ToggleButton>
			</ToggleButtonGroup>
		</Box>
	)
}